<!--
  Ultimate Tic-Tac-Toe.

  This game presents a collection of tic-tac-toe boards. The goal is to win
  several games of tic-tac-toe so that the wins create three-in-a-row.

  Additionally, when a player plays their piece in a cell, that piece
  determines in which board the next player is forced to play.

  Created in 2020.
-->
<script>
  import Board from './Board.svelte';
  import { STATE, calc_state} from './state.js';

  export let name;

  // The state of the game.
  let game_state = STATE.PLAYING;
  let end_msg = "";

  // The current_player in the game. Alternates between 0 and 1.
  let current_player = 0;

  // Booleans that represents whether a board is active.
  let is_active = [
    true, true, true,
    true, true, true,
    true, true, true
  ];

  // The starting state of each board.
  let board_state = [
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
    STATE.PLAYING, STATE.PLAYING, STATE.PLAYING,
  ]

  function moved(board_id, ev) {
    // Handles moved events sent from an active board.

    // It is unknown how many is_active is set to true here. Reset all.
    is_active = [
      false, false, false, false, false, false, false, false, false,
    ];

    if (ev.detail.board_state != STATE.PLAYING) {
      // The board that issued this event ended. Recalculate game_state.
      board_state[board_id] = ev.detail.board_state;
      game_state = calc_state(board_state);

      if (game_state == STATE.PLAYER_ONE || game_state == STATE.PLAYER_TWO)  {
        let color_name = current_player == 0 ? 'RED' : 'BLUE';
        end_msg = color_name + " player won!";
        return;
      } else if (game_state == STATE.TIED) {
        end_msg = "Game Tied!"
        return;
      } else {
        // Game continues
      }
    }

    // Game continues. Update player and is_active
    current_player = 1 - current_player;
    let cell_id = ev.detail.cell_id;
    if (board_state[cell_id] > 0) {
      // The board that should be changed into is over => all active
      is_active = [true, true, true, true, true, true, true, true, true];
    } else {
      is_active[cell_id] = true;
    }
  }
</script>

<svelte:head>
<title>{ name }</title>
</svelte:head>

<main>
  <h1>Ultimate Tic-Tac-Toe</h1>
  <h2>Made with Svelte</h2>
  <div id="boards">
    {#each board_state as board, i}
      <Board
        bind:current_player
        bind:is_active="{ is_active[i] }"
        on:moved="{ (ev) => moved(i, ev) }"
      ></Board>
    {/each}
  </div>

  <p id="end_msg"
    class:game_state-0="{ game_state == 0 }"
    class:game_state-1="{ game_state == 1 }"
    class:game_state-2="{ game_state == 2 }"
    class:game_state-3="{ game_state == 3 }"
  >{ end_msg }</p>
</main>


<style>
:global(:root) {
  --p0: #ff3e00;
  --p1: #40b3ff;
  --gray: #676778;
}

main {
  width: 500px;
  margin: 0 auto;
  text-align: center;
}

h1, h2 {
  margin: 0.5em;

  color: var(--p0);

  font-size: 2em;
  font-weight: bold;
  text-transform: uppercase;
}

h2 {
  margin: 1em;

  font-size: 1.25em;
}

#boards {
  height: 500px;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;

  grid-column-gap: 4px;
  grid-row-gap: 4px;
}

#end_msg {
  margin-top: 1em;

  font-size: 1.75em;
  font-weight: bold;
  text-transform: uppercase;
}

#end_msg.game_state-0 {
  display: none;
}
#end_msg.game_state-1 {
  color: var(--p0);
}
#end_msg.game_state-2 {
  color: var(--p1);
}
#end_msg.game_state-3 {
  color: var(--gray);
}
</style>
